












import { inject, injectable } from "inversify";
import { ErrorCode, ErrorSeverity, ThrowErrorFunction, throwErrorRTTI } from "~/modules/error";
import { httpAdapterRTTI } from "~/backend/backend.rtti";
import { HttpAdapter } from "~/backend/HttpAdapter/HttpAdapter";
import { AuthenticationMethod } from "~/backend/HttpAdapter/authenticationMethods";
import { convertDateStringValuesToDate } from "~/utils/processHttpAdapterResponse";
import { extractFileNameFromPath } from "~/utils/extractFromPath";

import { IdpUrlResponse } from "../model/idpUrlResponse";
import { SSOLoginRequestBody } from "../model/sSOLoginRequestBody";
import { Token } from "../model/token";
import { TokenData } from "../model/tokenData";
import { TokenRefreshResult } from "../model/tokenRefreshResult";

import { FederatedAuthService } from "./federatedAuth.serviceInterface";

@injectable()
export class FederatedAuthServiceImpl implements FederatedAuthService {
    private httpAdapter: HttpAdapter;

    readonly #throwError: ThrowErrorFunction;

    constructor(
        @inject(httpAdapterRTTI) httpAdapter: HttpAdapter,
        @inject(throwErrorRTTI) throwError: ThrowErrorFunction
    ) {
        this.httpAdapter = httpAdapter;
        this.#throwError = throwError;
    }

    






    public async getIdpUrl(accountSid: string, sSOLoginRequestBody: SSOLoginRequestBody): Promise<IdpUrlResponse> {
        if (accountSid === null || accountSid === undefined) {
            const metadata = {
                module: "backend",
                severity: ErrorSeverity.Error,
                source: extractFileNameFromPath(__filename)
            };
            this.#throwError(ErrorCode.InvalidParams, metadata, "Required parameter accountSid was null or undefined.");
        }
        if (sSOLoginRequestBody === null || sSOLoginRequestBody === undefined) {
            const metadata = {
                module: "backend",
                severity: ErrorSeverity.Error,
                source: extractFileNameFromPath(__filename)
            };
            this.#throwError(
                ErrorCode.InvalidParams,
                metadata,
                "Required parameter sSOLoginRequestBody was null or undefined."
            );
        }
        const response = await this.httpAdapter.post<IdpUrlResponse>(
            `https://iam[environment].twilio.com/v1/Accounts/${encodeURIComponent(String(accountSid))}/authenticate`,
            undefined,
            sSOLoginRequestBody
        );
        const processedResponse = convertDateStringValuesToDate<IdpUrlResponse>(response);
        return processedResponse;
    }

    






    public async refreshToken(accountSid: string, token: Token): Promise<TokenRefreshResult> {
        if (accountSid === null || accountSid === undefined) {
            const metadata = {
                module: "backend",
                severity: ErrorSeverity.Error,
                source: extractFileNameFromPath(__filename)
            };
            this.#throwError(ErrorCode.InvalidParams, metadata, "Required parameter accountSid was null or undefined.");
        }
        if (token === null || token === undefined) {
            const metadata = {
                module: "backend",
                severity: ErrorSeverity.Error,
                source: extractFileNameFromPath(__filename)
            };
            this.#throwError(ErrorCode.InvalidParams, metadata, "Required parameter token was null or undefined.");
        }
        const response = await this.httpAdapter.post<TokenRefreshResult>(
            `https://iam[environment].twilio.com/v1/Accounts/${encodeURIComponent(String(accountSid))}/Tokens/refresh`,
            undefined,
            token
        );
        const processedResponse = convertDateStringValuesToDate<TokenRefreshResult>(response);
        return processedResponse;
    }

    






    public async validateToken(accountSid: string, token: Token, options?: object): Promise<TokenData> {
        if (accountSid === null || accountSid === undefined) {
            const metadata = {
                module: "backend",
                severity: ErrorSeverity.Error,
                source: extractFileNameFromPath(__filename)
            };
            this.#throwError(ErrorCode.InvalidParams, metadata, "Required parameter accountSid was null or undefined.");
        }
        if (token === null || token === undefined) {
            const metadata = {
                module: "backend",
                severity: ErrorSeverity.Error,
                source: extractFileNameFromPath(__filename)
            };
            this.#throwError(ErrorCode.InvalidParams, metadata, "Required parameter token was null or undefined.");
        }
        const response = await this.httpAdapter.post<TokenData>(
            `https://iam[environment].twilio.com/v1/Accounts/${encodeURIComponent(String(accountSid))}/Tokens/validate`,
            AuthenticationMethod.Basic,
            token,
            options
        );
        const processedResponse = convertDateStringValuesToDate<TokenData>(response);
        return processedResponse;
    }
}
